/**
 * 원본: @gc/common/constants/channel_types
 */

const COLORS: Record<string, string> = {
  youtube: '#FF0000',
  twitch: '#6441A4',
  tiktok: '#010101',
  facebook: '#38589b',
  instagram: '#bd1972',
  twitter: '#000000',
  steam_curator: '#495057',
  discord: '#5865f2',
  telegram: '#229ed9',
  bilibili: '#00AEEC',
  chzzk: '#00e589',
  afreeca: '#0545b1',
};

const TITLES: Record<string, string> = {
  youtube: 'YouTube',
  twitch: 'Twitch',
  tiktok: 'TikTok',
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'Twitter',
  discord: 'Discord',
  telegram: 'Telegram',
  steam_curator: 'Steam curator',
  bilibili: 'Bilibili',
  chzzk: 'Chzzk',
  afreeca: 'Soop',
};

export function getChannelTypeColor(type: string): string {
  return COLORS[type] || 'inherit';
}

export function getChannelTypeTitle(type: string): string {
  return TITLES[type] || type.charAt(0).toUpperCase() + type.slice(1);
}
